<div class="max-w-md mx-auto p-3" *ngIf="invite">

  <app-navbar *ngIf="user" [showBrand]="true"></app-navbar>

  <div *ngIf="!accepted" class="mt-12">
    <p>
      You are invited to join
      <br>
      <strong class="text-lg">{{invite.subject.name}}</strong>
    </p>

    <div class="my-6 bg-slate-800 p-3 rounded">

      <div class="flex flex-row gap-3">
        <div *ngIf="invite.createdBy" class="flex-shrink-0 ">
          <app-avatar [user]="invite.createdBy" size="sm"></app-avatar>
        </div>

        <div>
          <div [innerHtml]="parse(invite.message)">
          </div>
          <p *ngIf="selfieRequired">
            It is best to accept this invite on a phone or some device with a camera, because you will be asked to take a selfie during the registration process. This is to help build a sense of community by helping everyone in class put names to faces easily.
          </p>
          <p *ngIf="invite.createdBy" class="text-muted">
            {{invite.createdBy.givenName}} {{invite.createdBy.familyName}}
          </p>
        </div>

      </div>
    </div>


    <p *ngIf="!user">
      Please <a (click)="signIn()">sign in</a> to accept this invite.
    </p>

    <div *ngIf="hasInvalidEmail">
      <p>
        This invite requires that you sign in with an email address that ends with
        <app-email-suffixes [suffixes]="invite.requirements.emailSuffixes"></app-email-suffixes>
      </p>
      <p>
        Please <a (click)="signIn()">sign in</a> with a different account to accept this invite.
      </p>
    </div>


    <div *ngIf="!hasInvalidEmail && missingProfileFields.length">
      <p>
        To accept this invite, please <a (click)="editProfile()">edit your profile</a> to include <app-profile-fields [fields]="invite.requirements.fields"></app-profile-fields>
      </p>
    </div>

    <div *ngIf="user && !hasInvalidEmail && !missingProfileFields.length">
      <button (click)="accept()" mat-flat-button color="primary" class="w-full">Accept Invite</button>
    </div>

  </div>

  <div *ngIf="accepted" class="mt-12">
    <p>
      You have joined
      <br>
      <strong class="text-lg">{{invite.subject.name}}</strong>
    </p>

    <p class="my-6" *ngIf="!loadingAcceptees && acceptees">
      We'll see you soon!
    </p>

    <div *ngIf="loadingAcceptees" class="bg-slate-800 rounded-lg text-center p-6">
      <fa-icon icon="circle-notch" [spin]="true" size="3x"></fa-icon>
    </div>

    <div *ngIf="!loadingAcceptees && acceptees" class="bg-slate-800 rounded-lg">

      <mat-paginator (page)="handlePageEvent($event)"
                     [length]="acceptees.totalElements"
                     [pageSize]="acceptees.pageable.pageSize"
                     [showFirstLastButtons]="true"
                     [hidePageSize]="true"
                     [pageIndex]="acceptees.pageable.pageNumber"
                     aria-label="Select page">
      </mat-paginator>

      <div *ngFor="let acceptee of acceptees.content">
        <app-user-summary [user]="acceptee"></app-user-summary>
      </div>
    </div>
  </div>

</div>
